<template>
  <!-- Privacy Policy Consent -->
  <div id="cookieNotice" class="privacy-policy-modal">
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <!-- eslint-disable-next-line -->
          <p>This website uses cookies to analyze traffic and for other purposes. You consent to the cookies if you use this website.
          </p>
          <a
            role="button"
            class="btn btn-primary btn-lg"
            @click="acceptCookieConsent()"
          >
            Continue
          </a>
          <a
            role="button"
            class="btn btn-primary btn-lg"
            href="/privacy-policy"
          >
            Our Privacy Policy
            <i class="fa fa-angle-double-right" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PrivacyPolicy",
  mounted() {
    const cookieConsent = this.getCookie("user_cookie_consent");
    if (cookieConsent !== null) {
      document.getElementById("cookieNotice").style.display = "none";
    } else {
      document.getElementById("cookieNotice").style.display = "block";
    }
  },
  methods: {
    // Create cookie
    setCookie(cname, cvalue, exdays) {
      const d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      const expires = `expires=${d.toUTCString()}`;
      document.cookie = `${cname}=${cvalue};${expires};path=/`;
    },
    // Delete cookie
    deleteCookie(cname) {
      const d = new Date();
      d.setTime(d.getTime() + 24 * 60 * 60 * 1000);
      const expires = `expires= + ${d.toUTCString()}`;
      document.cookie = `${cname}=;${expires};path=/`;
    },
    // Read cookie
    getCookie(cname) {
      // eslint-disable-next-line
      const match = document.cookie.match(RegExp("(?:^|;\\s*)" + cname + "=([^;]*)"));
      return match ? match[1] : null;
    },
    // Set cookie consent
    acceptCookieConsent() {
      this.deleteCookie("user_cookie_consent");
      this.setCookie("user_cookie_consent", 1, 30);
      document.getElementById("cookieNotice").style.display = "none";
    },
  },
};
</script>
